import type { MapPoint } from '../types';

/**
 * Serializes immutable map-coordinate vertices for an SVG polygon `points` attribute.
 *
 * @param points Ordered polygon vertices in the shared renderer's unscaled SVG coordinate system.
 * @returns Space-separated `x,y` pairs accepted by `SVGPolygonElement`; never mutates `points`.
 */
export function buildPolygonPoints(points: readonly MapPoint[]): string {
  return points.map((point) => `${point.x},${point.y}`).join(' ');
}
